var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArbitrum96(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_arbitrum_96",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 96,
    height: 96,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lg_arbitrum",
    transform: "translate(-12.219 -12.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_1_",
    transform: "translate(20.218 15.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_14_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M94.427,80.29l6.56-11.132L118.67,96.7l.008,5.286-.058-36.372a2.74,2.74,0,0,0-1.267-2.182L85.518,45.119a2.805,2.805,0,0,0-2.432.012,2.618,2.618,0,0,0-.285.165l-.111.07-30.9,17.907-.12.054a2.794,2.794,0,0,0-.456.266,2.748,2.748,0,0,0-1.14,2.06l.049,29.639L66.59,69.763c2.074-3.385,6.592-4.475,10.786-4.416l4.923.13-29,46.516,3.419,1.968L86.065,65.524l12.974-.047L69.763,115.136l12.2,7.017,1.458.838a2.8,2.8,0,0,0,1.965.039l32.283-18.709L111.5,107.9Zm2.5,36.05L84.607,97l7.522-12.764,16.183,25.508Z",
    transform: "translate(-44.578 -39.359)",
    fill: "#2d374b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M237.768,271.679l12.322,19.34,11.383-6.6L245.29,258.915Z",
    transform: "translate(-197.739 -214.038)",
    fill: "#28a0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M315.386,209.8l-.008-5.286-17.683-27.542-6.56,11.132,17.07,27.608,6.172-3.577a2.736,2.736,0,0,0,1.01-1.992Z",
    transform: "translate(-241.285 -147.169)",
    fill: "#28a0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M20.219,197.871l8.716,5.022,29-46.515-4.923-.13c-4.194-.059-8.712,1.031-10.786,4.416L25.76,186.193l-5.541,8.514Z",
    transform: "translate(-20.219 -130.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M128.5,156.964l-12.974.047L86.17,205.448l10.259,5.907,2.79-4.732Z",
    transform: "translate(-74.035 -130.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M99.786,41.068a8.264,8.264,0,0,0-3.879-6.643L63.653,15.877a8.391,8.391,0,0,0-7.4,0c-.27.136-31.366,18.17-31.366,18.17a8.255,8.255,0,0,0-4.67,7V79.464l5.541-8.514-.048-29.639a2.64,2.64,0,0,1,.039-.32,2.729,2.729,0,0,1,1.1-1.74c.146-.1,31.774-18.412,31.874-18.462a2.806,2.806,0,0,1,2.432-.012L92.994,39.09a2.74,2.74,0,0,1,1.267,2.182V77.987a2.677,2.677,0,0,1-.952,1.992l-6.172,3.577L83.952,85.4,72.569,92l-11.544,6.69a2.8,2.8,0,0,1-1.965-.039L45.4,90.794l-2.79,4.732,12.274,7.067c.406.231.767.436,1.064.6.459.258.773.43.883.484a7.974,7.974,0,0,0,3.259.67,8.206,8.206,0,0,0,3.005-.565L96.627,84.366a8.2,8.2,0,0,0,3.159-6.176Z",
    transform: "translate(-20.218 -15.017)",
    fill: "#96bedc"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArbitrum96);
export default __webpack_public_path__ + "static/media/ic_arbitrum_96.4c6d42bfadfbf94cebc7d426378dd47b.svg";
export { ForwardRef as ReactComponent };